const mergeArraysToOptions = (existedOptions, newOptions) => {
  const existedValues = Array.from(existedOptions.map(({ value }) => value));
  const newValues = newOptions.flat(Infinity).filter((item) => !!item);
  const uniqueValues = Array.from(new Set([...existedValues, ...newValues]));

  return uniqueValues.map((val) => ({ value: val, label: val }));
};

export default mergeArraysToOptions;
